import { useEffect, useState } from "react";
import {
    Button, Col, Form, FormGroup, Input, Label,
    Modal, ModalBody, ModalHeader, ModalFooter, Row,
    CardBody,
    Card,
    Container,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { receiptNoteActions } from "../../sagas/receiptNoteSlice";
import { supplierActions } from "../../sagas/supplierSlice";
import { entrepotActions } from "../../sagas/entrepotSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import ReceptionLines from "./ReceptionLines";
import { formatPrice } from "../../helpers/utility";
import {
    FaWarehouse, FaUser, FaMoneyBillWave, FaBuilding,
    FaIdCard, FaPhone, FaEnvelope, FaMapMarkerAlt, FaBusinessTime
} from "react-icons/fa";
import "./pos-reception-form.css";
import POSKeypadModal from "./POSKeypadModal";
import SupplierSelectModal from "./SupplierSelectModal";
import POSProductFormModal from "./POSProductFormModal";
import { categoryActions } from "../../sagas/categorySlice";
import { productActions } from "../../sagas/productSlice";
import POSHeader from "./POSHeader";
import { CBL_PAGE, CPMT_PRODUCTS_PAGE, CPMT_RECEPTION_PAGE, CPMT_STOCK_PAGE, CPMT_TRANSFER_PAGE, PAY_PAGE, RETOUR_PAGE } from "../../routes/routeConstants";
import { useLocation, useNavigate } from "react-router-dom";

const villesMaroc = ['Casablanca', 'Rabat', 'Khouribga', 'Marrakech', 'Fès', 'Tanger', 'Agadir', 'Meknès', 'Oujda', 'Kénitra', 'Tétouan', 'Safi', 'Mohammedia', 'El Jadida', 'Nador', 'Beni Mellal'];



const CReceiptNoteNew = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const reception = location.state?.reception;
    const { suppliers } = useSelector(s => s.suppliers);
    const { entrepots } = useSelector(s => s.entrepots);

    const [supplierModal, setSupplierModal] = useState(false);
    const [entrepotModal, setEntrepotModal] = useState(false);
    const [showSupplierModal, setShowSupplierModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [keypadOpen, setKeypadOpen] = useState(false);
    const [keypadField, setKeypadField] = useState(null);
    const [keypadValue, setKeypadValue] = useState("");
    const [docKeypadOpen, setDocKeypadOpen] = useState(false);
    const [docKeypadValue, setDocKeypadValue] = useState("");
    const [categoryModal, setCategoryModal] = useState(false);
  const {role,  businessName, email, address, telephone, fullName, commercialId, pointOfSaleId } = useSelector((state) => state.auth);
    const isAdmin = role === "ROLE_ADMIN";
    const openDeliveryNoteKeypad = () => {
        setDocKeypadValue(values.deliveryNoteNb || "");
        setDocKeypadOpen(true);
    };
    const [activeTab, setActiveTab] = useState("RECEPTION");

    const [fournisseur, setFournisseur] = useState({
        nom: '', prenom: '', cin: '', telephone1: '', telephone2: '',
        email: '', adresse: '', ville: 'Casablanca', typeFournisseur: 'PARTICULIER',
        codePostal: '', plafond: 0, entreprise: '', ice: '', active: true, solde: 0
    });

    useEffect(() => {
        dispatch(supplierActions.search({ query: "" }));
        dispatch(entrepotActions.list());
        dispatch(categoryActions.list({ query: "" }));
        dispatch(productActions.findAllUnites());
    }, []);

    const handleFournisseurChange = e => {
        const { name, value } = e.target;
        setFournisseur(prev => ({
            ...prev,
            [name]: name === "active" ? value === "true" : value
        }));
    };

    const formik = useFormik({
        initialValues: {
            fournisseurId: reception?.fournisseurId || null,
            fournisseurNom: reception?.fournisseurNom || "",
            entrepotId: reception?.entrepotId || null,
            dateReception: reception?.dateReception || new Date().toISOString().split("T")[0],
            deliveryNoteNb: reception?.deliveryNoteNb || "",
            modeReglement: reception?.modeReglement || "ESPECES",
            lignes: reception?.lignes || [],
            montantTotalHT: reception?.montantTotalHT || 0,
            montantTotalTaxe: reception?.montantTotalTaxe || 0,
            montantTotalTTC: reception?.montantTotalTTC || 0,
            statut: reception?.statut || "EN_ATTENTE",
        },
        validationSchema: Yup.object({
            fournisseurId: Yup.number().required(),
            entrepotId: Yup.number().required(),
            deliveryNoteNb: Yup.string().required(),
            lignes: Yup.array().min(1),
        }),
        onSubmit: values => {
            const payload = {
                data: values,
                onSuccess: () => {
                    Swal.fire("OK", "Réception enregistrée", "success");
                    navigate(CPMT_RECEPTION_PAGE);
                }
            };
            reception
                ? dispatch(receiptNoteActions.updateReceiptNote({ ...payload, id: reception.id }))
                : dispatch(receiptNoteActions.createReceiptNote(payload));
        }
    });

    const { values, setFieldValue, handleSubmit } = formik;

    const isReadOnly = values.statut === "VALIDE";

    /* ---------------- CREATE SUPPLIER ---------------- */
    const handleSupplierSubmit = () => {
        const newErrors = {};
        if (!fournisseur.telephone1) newErrors.telephone1 = 'Téléphone obligatoire';
        if (fournisseur.typeFournisseur === 'PARTICULIER') {
            if (!fournisseur.nom) newErrors.nom = 'Nom obligatoire';
            if (!fournisseur.prenom) newErrors.prenom = 'Prénom obligatoire';
        }
        if (fournisseur.typeFournisseur === 'ENTREPRISE') {
            if (!fournisseur.entreprise) newErrors.entreprise = 'Entreprise obligatoire';
        }
        if (Object.keys(newErrors).length) return setErrors(newErrors);

        dispatch(supplierActions.addSupplier({
            data: fournisseur,
            onSuccess: created => {
                setFieldValue("fournisseurId", created.id);
                setFieldValue("fournisseurNom", created.nom || created.entreprise);
                setShowSupplierModal(false);
                setErrors({});
                Swal.fire("Succès", "Fournisseur créé", "success");
            }
        }));
    };

    return (
        <Container fluid className="pos-page">
            <POSHeader
                businessName={businessName}
                commercialId={commercialId}
                pointOfSaleId={pointOfSaleId}
                fullName={fullName}
                isAdmin={isAdmin}
                activeTab={activeTab}
                onChangeTab={(tab) => {
                    setActiveTab(tab);
                    if (tab === "VENTES") navigate(CBL_PAGE);
                    if (tab === "STOCK") navigate(CPMT_STOCK_PAGE);
                    if (tab === "PRODUCTS") navigate(CPMT_PRODUCTS_PAGE);
                    if (tab === "AVANCE") navigate(PAY_PAGE);
                    if (tab === "RETOURS") navigate(RETOUR_PAGE);
                    if (tab === "RECEPTION") navigate(CPMT_RECEPTION_PAGE);
                    if (tab === "TRANSFER") navigate(CPMT_TRANSFER_PAGE);
                }}
            />
            <Form onSubmit={handleSubmit} className="pos-form">
                {isReadOnly && (
                    <div className="pos-locked-banner">
                        🔒 Réception validée — modification impossible
                    </div>
                )}
                {/* ================= HEADER CARD ================= */}
                <Card className="pos-card shadow-sm mb-3">
                    <CardBody className="p-3">

                        <Row className="g-3">
                            <Col md={2}>
                                <Label className="pos-label">Fournisseur</Label>
                                <Button color="light" block className="pos-select-btn" onClick={() => !isReadOnly && setSupplierModal(true)}
                                    disabled={isReadOnly}>
                                    <FaUser /> {values.fournisseurNom || "Choisir fournisseur"}
                                </Button>
                            </Col>

                            <Col md={2}>
                                <Label className="pos-label">Entrepôt</Label>
                                <Button
                                    color="light"
                                    block
                                    className="pos-select-btn"
                                    onClick={() => !isReadOnly && setEntrepotModal(true)}
                                    disabled={isReadOnly}
                                >
                                    <FaWarehouse /> {entrepots.find(e => e.id === values.entrepotId)?.libelle || "Choisir entrepôt"}
                                </Button>
                            </Col>

                            <Col md={2}>
                                <Label className="pos-label">Date réception</Label>
                                <Input
                                    type="date"
                                    value={values.dateReception}
                                    onChange={e => setFieldValue("dateReception", e.target.value)}
                                    className="pos-input"
                                    disabled={isReadOnly}
                                />
                            </Col>

                            <Col md={2}>
                                <Label className="pos-label">N° Bon Livraison</Label>
                                <Input
                                    type="text"
                                    value={values.deliveryNoteNb}
                                    onClick={() => !isReadOnly && openDeliveryNoteKeypad()}
                                    className="pos-input"
                                    disabled={isReadOnly}
                                />
                            </Col>

                            <Col md={4}>
                                <Label className="pos-label">Mode règlement</Label>
                                <div className="d-flex gap-2 flex-wrap">
                                    {["ESPECES", "CHEQUE", "VIREMENT"].map(m => (
                                        <Button
                                            key={m}
                                            color={values.modeReglement === m ? "primary" : "light"}
                                            onClick={() => !isReadOnly && setFieldValue("modeReglement", m)}
                                            disabled={isReadOnly}
                                            className="pos-mode-btn"
                                        >
                                            <FaMoneyBillWave /> {m}
                                        </Button>
                                    ))}
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>


                {/* ================= LINES CARD ================= */}
                <Card className="pos-card shadow-sm mb-3 pos-lines-card">
                    <CardBody className="p-2">
                        <ReceptionLines formik={formik} readOnly={isReadOnly} />
                    </CardBody>
                </Card>


                {/* ================= FOOTER BAR ================= */}
                <Card className="pos-footer-bar shadow-sm">
                    <CardBody className="p-3">

                        <Row className="align-items-center">
                            <Col md={6} className="pos-totals">

                                <div>Montant TTC : <strong className="text-primary">{formatPrice(values.montantTotalTTC)}</strong></div>
                            </Col>

                            <Col md={6} className="d-flex justify-content-end align-items-center gap-2">
                                <Button
                                    color="secondary"
                                    className="pos-action-btn"
                                    onClick={() => navigate(CPMT_RECEPTION_PAGE)}
                                >
                                    Annuler
                                </Button>

                                {!isReadOnly && (
                                    <Button
                                        color="primary"
                                        type="submit"
                                        className="pos-action-btn"
                                    >
                                        Enregistrer
                                    </Button>
                                )}
                            </Col>
                        </Row>

                    </CardBody>
                </Card>

            </Form>



            {/* ENTREPOT LIST */}
            <Modal isOpen={entrepotModal} toggle={() => setEntrepotModal(false)}>
                <ModalHeader>Choisir Entrepôt</ModalHeader>
                <ModalBody>
                    {entrepots.map(e => (
                        <Button key={e.id} block color="light"
                            onClick={() => { setFieldValue("entrepotId", e.id); setEntrepotModal(false); }}>
                            {e.code} - {e.libelle}
                        </Button>
                    ))}
                </ModalBody>
            </Modal>


            <POSKeypadModal
                isOpen={keypadOpen}
                toggle={() => setKeypadOpen(false)}
                value={keypadValue}
                onChange={setKeypadValue}
                onConfirm={(val) => {
                    setFournisseur(prev => ({
                        ...prev,
                        [keypadField]: val
                    }));
                    setKeypadOpen(false);
                }}
                title="Saisie Fournisseur"
            />

            <Modal
                isOpen={showSupplierModal}
                toggle={() => setShowSupplierModal(false)}
                size="xl"
                centered
                className="pos-client-modal"
            >
                <ModalHeader
                    toggle={() => setShowSupplierModal(false)}
                    className="border-0 pb-0"
                >
                    <div className="d-flex flex-column">
                        <div className="fw-bold fs-4">{t("client.newClient")}</div>
                        <small className="text-muted">Ajoutez rapidement un fournisseur</small>
                    </div>
                </ModalHeader>

                <ModalBody className="pt-2">
                    <Card className="border-0 shadow-sm rounded-4">
                        <CardBody className="p-3">
                            {/* TYPE CLIENT POS TOGGLE */}
                            <Row className="g-3 mb-2">
                                <Col md={12}>
                                    <Label className="fw-bold text-muted mb-2">
                                        <FaIdCard className="me-2" />
                                        Type de client *
                                    </Label>

                                    <div className="d-flex gap-2 flex-wrap">
                                        <Button
                                            color={fournisseur.typeFournisseur === "PARTICULIER" ? "primary" : "light"}
                                            className="fw-bold px-4 py-2 rounded-3 border"
                                            onClick={() =>
                                                setFournisseur((prev) => ({ ...prev, typeFournisseur: "PARTICULIER" }))
                                            }
                                        >
                                            Particulier
                                        </Button>

                                        <Button
                                            color={fournisseur.typeFournisseur === "ENTREPRISE" ? "primary" : "light"}
                                            className="fw-bold px-4 py-2 rounded-3 border"
                                            onClick={() =>
                                                setFournisseur((prev) => ({ ...prev, typeFournisseur: "ENTREPRISE" }))
                                            }
                                        >
                                            Entreprise
                                        </Button>
                                    </div>
                                </Col>
                            </Row>

                            {/* DYNAMIC FIELDS */}
                            {fournisseur.typeFournisseur === "PARTICULIER" && (
                                <Row className="g-3">
                                    <Col md={4}>
                                        <Label className="fw-bold">
                                            <FaUser className="me-2 text-muted" />
                                            Nom *
                                        </Label>
                                        <Input
                                            name="nom"
                                            value={fournisseur.nom}
                                            onChange={handleFournisseurChange}
                                            placeholder="El Fassi"
                                            invalid={!!errors.nom}
                                            className="py-2 rounded-3"
                                        />
                                        {errors.nom && (
                                            <div className="text-danger small mt-1">{errors.nom}</div>
                                        )}
                                    </Col>

                                    <Col md={4}>
                                        <Label className="fw-bold">
                                            <FaUser className="me-2 text-muted" />
                                            Prénom *
                                        </Label>
                                        <Input
                                            name="prenom"
                                            value={fournisseur.prenom}
                                            onChange={handleFournisseurChange}
                                            placeholder="Karim"
                                            invalid={!!errors.prenom}
                                            className="py-2 rounded-3"
                                        />
                                        {errors.prenom && (
                                            <div className="text-danger small mt-1">{errors.prenom}</div>
                                        )}
                                    </Col>
                                    <Col md={4}>
                                        <Label className="fw-bold">
                                            <FaPhone className="me-2 text-muted" />
                                            Téléphone (1) *
                                        </Label>
                                        <Input
                                            name="telephone1"
                                            value={fournisseur.telephone1}
                                            onChange={handleFournisseurChange}
                                            placeholder="06 12 34 56 78"
                                            invalid={!!errors.telephone1}
                                            className="py-2 rounded-3"
                                        />
                                        {errors.telephone1 && (
                                            <div className="text-danger small mt-1">{errors.telephone1}</div>
                                        )}
                                    </Col>
                                </Row>
                            )}

                            {fournisseur.typeFournisseur === "ENTREPRISE" && (
                                <Row className="g-3">
                                    <Col md={4}>
                                        <Label className="fw-bold">
                                            <FaBuilding className="me-2 text-muted" />
                                            Entreprise *
                                        </Label>
                                        <Input
                                            name="entreprise"
                                            value={fournisseur.entreprise}
                                            onChange={handleFournisseurChange}
                                            placeholder="Nom de l'entreprise"
                                            invalid={!!errors.entreprise}
                                            className="py-2 rounded-3"
                                        />
                                        {errors.entreprise && (
                                            <div className="text-danger small mt-1">{errors.entreprise}</div>
                                        )}
                                    </Col>

                                    <Col md={4}>
                                        <Label className="fw-bold">
                                            <FaIdCard className="me-2 text-muted" />
                                            ICE *
                                        </Label>
                                        <Input
                                            name="ice"
                                            value={fournisseur.ice}
                                            onChange={handleFournisseurChange}
                                            placeholder="Numéro ICE"
                                            invalid={!!errors.ice}
                                            className="py-2 rounded-3"
                                        />
                                        {errors.ice && (
                                            <div className="text-danger small mt-1">{errors.ice}</div>
                                        )}
                                    </Col>
                                    <Col md={4}>
                                        <Label className="fw-bold">
                                            <FaPhone className="me-2 text-muted" />
                                            Téléphone (1) *
                                        </Label>
                                        <Input
                                            name="telephone1"
                                            value={fournisseur.telephone1}
                                            onChange={handleFournisseurChange}
                                            placeholder="06 12 34 56 78"
                                            invalid={!!errors.telephone1}
                                            className="py-2 rounded-3"
                                        />
                                        {errors.telephone1 && (
                                            <div className="text-danger small mt-1">{errors.telephone1}</div>
                                        )}
                                    </Col>
                                </Row>
                            )}


                        </CardBody>
                    </Card>
                </ModalBody>
                {/* POS FOOTER */}
                <ModalFooter className="border-0 d-flex justify-content-end gap-2">
                    <Button
                        color="secondary"
                        outline
                        className="fw-bold px-4 py-2 rounded-3"
                        onClick={() => setShowSupplierModal(false)}
                    >
                        {t("common.cancel")}
                    </Button>

                    <Button
                        color="primary"
                        className="fw-bold px-4 py-2 rounded-3"
                        onClick={handleSupplierSubmit}
                    >
                        {t("common.save")}
                    </Button>
                </ModalFooter>
            </Modal>
            <SupplierSelectModal
                isOpen={supplierModal}
                toggle={() => setSupplierModal(false)}
                suppliers={suppliers}
                selectedSupplier={suppliers.find(s => s.id === values.fournisseurId)}

                onSelect={(s) => {
                    if (!s) {
                        setFieldValue("fournisseurId", null);
                        setFieldValue("fournisseurNom", "");
                        return;
                    }

                    setFieldValue("fournisseurId", s.id);
                    setFieldValue("fournisseurNom", s.nom || s.entreprise);
                }}

                onAddNew={() => {
                    setSupplierModal(false);
                    setTimeout(() => setShowSupplierModal(true), 300);
                }}
            />

            <POSKeypadModal
                isOpen={docKeypadOpen}
                toggle={() => setDocKeypadOpen(false)}
                value={docKeypadValue}
                onChange={setDocKeypadValue}
                onSearch={(val) => {
                    setFieldValue("deliveryNoteNb", docKeypadValue);
                    setDocKeypadOpen(false);
                }}
                title="Numéro Bon Livraison"
            />


        </Container>
    );
};

export default CReceiptNoteNew;
